<template>
  <div class="text-left">
    <v-card>
      <v-form class="pa-6" ref="form">
        <v-row>
          <v-col cols="12">
            <h3 class="text-left">{{ $t("title.funderProgramData") }}</h3>
          </v-col>
        </v-row>

        <h5>
          {{ $t("form.name") }}
        </h5>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="funderProgram.name.es"
              :label="$t('form.es')"
              required
              outlined
              :rules="rules.char_required_max_200"
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="funderProgram.name.gl"
              :label="$t('form.gl')"
              required
              outlined
              :rules="rules.char_required_max_200"
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="funderProgram.name.en"
              :label="$t('form.en')"
              required
              outlined
              :rules="rules.char_required_max_200"
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
            
        <h5>
          {{ $t("form.internal_name") }}
        </h5>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="funderProgram.internal_name"
              :label="$t('form.internal_name')"
              required
              outlined
              :rules="rules.char_required_max_220"
              :counter="220"
            ></v-text-field>
          </v-col>
        </v-row>
        <h5>
          {{ $t("section.organization") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-combobox
              v-model="funderProgram.organization"
              :items="organizations"
              item-value="id"
              item-text="name"
              :return-object="true"
              :label="$t('section.organization')"
              outlined
              :rules="rules.fieldRequired"
            ></v-combobox>
          </v-col>
        </v-row>
        <h5>
          {{ $t("form.organization.logo") }} (Español)
        </h5>
        <UploadImage
          :path="$store.state.endpoint + '/funderProgram/' + $route.params.id"
          :url="$store.state.endpoint + funderProgram.logo_es"
          :object="{ name: funderProgram.logo_es }"
          :object_created="$route.params.id !== undefined"
          name_field="logo_es"
        />
        <h5>
          {{ $t("form.organization.logo") }} (Galego)
        </h5>
        <UploadImage
          :path="$store.state.endpoint + '/funderProgram/' + $route.params.id"
          :url="$store.state.endpoint + funderProgram.logo_gl"
          :object="{ name: funderProgram.logo_gl }"
          :object_created="$route.params.id !== undefined"
          name_field="logo_gl"
        />
        <h5>
          {{ $t("form.organization.logo") }} (English)
        </h5>
        <UploadImage
          :path="$store.state.endpoint + '/funderProgram/' + $route.params.id"
          :url="$store.state.endpoint + funderProgram.logo_en"
          :object="{ name: funderProgram.logo_en }"
          :object_created="$route.params.id !== undefined"
          name_field="logo_en"
        />
        <v-divider />
        <div class="text-center">
          <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
          <v-btn color="primary" @click="save" class="ml-2"><v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}</v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
import UploadImage from "../../components/layouts/UploadImage";
import project_model from "../../mixins/model_utils/project_model";

export default {
  components: { UploadImage },
  mixins: [validationRules, project_model],
  name: "EditFunderProgramDetail",
  data: () => ({
    funderProgram: {
      name: { es: "", en: "", gl: "" },
      internal_name: "",
      organization: "",
      logo: null
    }
  }),

  created() {
    this.getOrganizations();
    if (this.$route.params.id > -1) {
      this.getFunderProgram();
    }
  },

  computed: {
    processData() {
      let data = {
        name: this.funderProgram.name,
        internal_name: this.funderProgram.internal_name,
        organization: this.funderProgram.organization.id
      };
      return data;
    }
  },

  methods: {
    getFunderProgram() {
      let path =
        this.$store.state.endpoint + "/funderProgram/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.funderProgram = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        if (this.$route.params.id > -1) {
          path =
            this.$store.state.endpoint +
            "/funderProgram/" +
            this.$route.params.id;
          axios
            .patch(path, this.processData)
            .then(() => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
              this.$router.push("/manage/edit/funderPrograms");
            })
            .catch(error => {
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/funderProgram";
          axios
            .post(path, this.processData)
            .then(response => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
              this.$router.push(
                "/manage/edit/funderProgram/edit/" + response.data.id
              );
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
      }
    }
  }
};
</script>
